const SET_DATA_BACKUP_STATUS = 'SET_DATA_BACKUP_STATUS';

function setDataBackupStatus(isDataBackuped) {
    return { type: SET_DATA_BACKUP_STATUS, isDataBackuped };
}

export { SET_DATA_BACKUP_STATUS, setDataBackupStatus };
